import { createStyles } from "@app/components/tss/hooks/use-tss-styles";

export const useStyles = createStyles(({ theme }) => {
  const { colors, styles, spacing } = theme.busbud;
  const { shadow, opacity, rounding } = styles;

  const seat_size = 5;
  const spacing_between_selector_and_seat = 1;

  return {
    root: {
      maxWidth: spacing(22.5),
      boxShadow: shadow.subtle.lg,
      borderRadius: rounding.xxl,
      zIndex: 3 // necessary to appear over the modal
    },
    horizontal: {
      position: "absolute",
      bottom: "auto",
      top: spacing(seat_size + spacing_between_selector_and_seat)
    },
    vertical: {
      position: "fixed",
      bottom: spacing(20)
    },
    available: {
      "&:hover": {
        cursor: "pointer"
      }
    },
    disabled: {
      "& > *": {
        opacity: opacity[500]
      }
    },
    item: {
      backgroundColor: colors.background.primary.opaque,
      padding: spacing(1.125, 3, 1),
      width: "50%"
    },
    seat: {
      cursor: "default"
    },
    left: {
      borderRadius: `${rounding.xxl} ${rounding.md} ${rounding.md} ${rounding.xxl}`
    },
    right: {
      borderRadius: `${rounding.md} ${rounding.xxl} ${rounding.xxl} ${rounding.md}`
    },

    firstRow: { top: spacing(-(seat_size + 2.5)) },
    lastColumn: { right: 0 }
  };
});
